import React from 'react';
import './HeroSection.css';

const HeroSection = ({ config, className = "" }) => {
  return (
    <div className={`hero-section ${className}`}>
      <div className="hero-background">
        <img 
          src={config.backgroundImage} 
          alt={config.altText} 
          className="hero-image"
        />
      </div>
      
      {config.title && (
        <div className="hero-content">
          <h1 className="hero-title">
            {config.title === "Where modern living meets smart investment." ? (
              <>
                <span className="line-1">Where modern</span>
                <span className="line-2">living meets smart</span>
                <span className="line-3">investment.</span>
              </>
            ) : (
              config.title
            )}
          </h1>
        </div>
      )}
    </div>
  );
};

export default HeroSection;
